<template>
    <PaymentAction :id="$route.params.id" @close="$router.push({ path: '/payments' })" />
</template>

<script>
import PaymentAction from "@/components/shared/PaymentAction";

export default {
    components: { PaymentAction },
};
</script>